import { MessageBox } from 'element-ui';
import store from '../../store';
import router from '../../router';
import httpService from '@/service/http-service';
import API from '@/api/login';
import BASE_API from '@/api/dataBase';
import XEUtils from 'xe-utils/methods/xe-utils';
import globalVar from '@/common/js/global';
//计算方法
import cal from '@/common/js/calculation';
// import Vue from 'vue';

//控制错误弹框状态
let requestStatus = true;
/**
 * 存储localStorage
 */
export const setLocalStorage = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
export const getLocalStorage = (name) => {
  if (!name) return;
  let data = window.localStorage.getItem(name);
  return data ? JSON.parse(data) : undefined;
};

/**
 * 删除localStorage
 */
export const removeLocalStorage = (name) => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/**
 * token管理
 */
export const refreshTokenExir = () => {
  return new Promise((resolve, reject) => {
    const params = {
      access_token: store.state.userInfo.userInfo.access_token,
      // refresh_token
    };
    httpService
      .get(API.REFRESH_TOKEN_EXIR, params)
      .then((res) => {
        if (res.data.code === 0) {
          let response = res.data.data;
          store.state.userInfo.userInfo.expir = response.expir;
          store.state.userInfo.userInfo.access_token = response.token.access_token;
          store.state.userInfo.userInfo.refresh_token = response.token.refresh_token;
          store.commit('saveUserInfo', store.state.userInfo.userInfo);
          globalVar.refreshTokenFlag = 0;
          resolve(response);
        } else {
          globalVar.refreshTokenFlag = 0;
          reject();
        }
      })
      .catch(() => {
        globalVar.refreshTokenFlag = 0;
        reject();
      });
  });
};

//js方法格式化数字，加入千分符
export function fmoney(s, n = 2) {
  //s为值 n为小数点位数
  if (s == '*') {
    return s;
  }
  n = n >= 0 && n <= 20 ? n : 2;
  s = parseFloat((s + '').replace(/[^\d\.-]/g, '')).toFixed(n) + '';
  var l = s.split('.')[0].split('').reverse(),
    r = s.split('.')[1];
  r = r == null ? '' : '.' + r;
  var t = '';
  if (l[l.length - 1] === '-') {
    //负数不需要分隔号,
    for (let i = 0; i < l.length; i++) {
      if (l[i] === '-') {
        t += l[i] + '';
        continue;
      }
      //不是数组的倒数第二个元素才加"," ["0", "4", "5", "-"]
      t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length - 1 ? ',' : '');
    }
  } else {
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? ',' : '');
    }
  }
  return t.split('').reverse().join('') + r;
}

/**
 * 去除千分位
 *@param{Object}num
 */

export function delcommafy(num) {
  if (typeof num == 'string') {
    if (num.indexOf(',') != -1) {
      num = num.replace(/,/gi, '');
    }
    if (num.indexOf(' ') != -1) {
      num = num.replace(/[ ]/g, ''); //去除空格
    }
  }
  return num * 1;
}

// translate router.meta.title, be used in breadcrumb sidebar tagsview
export function generateTitle(title) {
  const hasKey = this.$te('router.' + title);

  if (hasKey) {
    // $t :this method from vue-i18n, inject in @/lang/index.js
    const translatedTitle = this.$t('router.' + title);

    return translatedTitle;
  }
  return title;
}

//排序规则
export function sortby(name, minor, sort) {
  return function (o, p) {
    var a, b;
    if (o && p && typeof o === 'object' && typeof p === 'object') {
      a = o[name];
      b = p[name];
      if (a === b) {
        return typeof minor === 'function' ? minor(o, p) : 0;
      }
      if (typeof a === typeof b) {
        a = parseFloat(a.toString().replace(/,/g, ''));
        b = parseFloat(b.toString().replace(/,/g, ''));
        if (sort == 'ascending') {
          return a < b ? -1 : 1;
        } else if (sort == 'descending') {
          return a < b ? 1 : -1;
        }
      }
      if (sort == 'ascending') {
        return typeof a < typeof b ? -1 : 1;
      } else if (sort == 'descending') {
        return typeof a < typeof b ? 1 : -1;
      }
    } else {
      throw 'error';
    }
  };
}

/* 判断两个对象是否重复 */
export const isEqual = (a, b, name) => {
  //获取a和b的属性长度
  let propsA = Object.getOwnPropertyNames(a);
  // let propsB = Object.getOwnPropertyNames(b);
  // if (propsA.length != propsB.length) {
  //     return false;
  // }
  for (let i = 0; i < propsA.length; i++) {
    let propName = propsA[i];
    //如果对应属性对应值不相等，则返回false
    if (propName == name && a[propName] !== b[propName]) {
      return false;
    }
  }
  return true;
};

/** 获取用户下的公司列表 */
export function getUserCompanyList() {
  const str = getLocalStorage('userInfo').userInfo.companyList;
  if (!str) return [];
  const list = JSON.parse(str);
  return list.map((item) => {
    return {
      value: item.personCompanyCode,
      label: item.personCompanyName,
    };
  });
}

export const getRouteMenuCode = () => {
  let response = new Promise((resolve) => {
    const params = {
      applicationCode: getLocalStorage('userInfo').userInfo.applicationCode,
      menuUrl: router.currentRoute.path,
    };
    httpService.post(API.GET_MENU_CODE_API, params).then((res) => {
      if (0 == res.data.code) {
        response = res.data.data;
        store.state.userInfo.userInfo.menuCode = res.data.data;
        store.commit('saveUserInfo', store.state.userInfo.userInfo);
        resolve(response);
      } else {
        return null;
      }
    });
  });
  return response;
};

/**
 * 获取列表按钮
 */
export const getButtons = () => {
  let response = new Promise((resolve) => {
    getRouteMenuCode().then((e) => {
      httpService
        .post(
          '/maindata/role/getRoleMenuButton' +
            '?MENU_CODE=' +
            e +
            '&USER_NAME=' +
            getLocalStorage('userInfo').userInfo.account
        )
        .then((res) => {
          if (0 == res.data.code) {
            response = res.data.data || [];
            resolve(response);
          } else {
            return null;
          }
        });
    });
  });
  return response;
};

/**
 * 获取列
 */
export const getColumnList = (columns) => {
  let response = new Promise((resolve, reject) => {
    const params = {
      userId: getLocalStorage('userInfo').userInfo.userCode,
      menuCode: getLocalStorage('userInfo').userInfo.menuCode,
      departmentCode: getLocalStorage('userInfo').userInfo.departmentCode,
      companyCode: getLocalStorage('userInfo').userInfo.companyCode,
    };
    httpService.get(BASE_API.GET_COLUMNS_LIST_API, params).then((res) => {
      if (0 == res.data.code) {
        resolve(res.data.data.length == 0 ? columns : res.data.data);
      } else {
        return reject();
      }
    });
  });
  return response;
};

//将数字转换成人民币大写的方法
export const digitUppercase = (n) => {
  var fraction = ['角', '分'];
  var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  var unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟'],
  ];
  var IsNum = Number(n);
  if (!isNaN(IsNum)) {
    var head = n < 0 ? '欠' : '';
    n = Math.abs(n);
    var s = '';
    for (let i = 0; i < fraction.length; i++) {
      s += (
        digit[Math.floor(((n * 100).toFixed(2) / 10) * Math.pow(10, i)) % 10] + fraction[i]
      ).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (let i = 0; i < unit[0].length && n > 0; i++) {
      var p = '';
      for (var j = 0; j < unit[1].length && n > 0; j++) {
        p = digit[n % 10] + unit[1][j] + p;
        n = Math.floor(n / 10);
      }
      s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return (
      head +
      s
        .replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元')
    );
  } else {
    return '';
  }
};

//将数字转换成大写的方法
export const toUpperCase = (n) => {
  var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  var unit = [
    ['', '万', '亿'],
    ['', '拾', '佰', '仟'],
  ];
  var IsNum = Number(n);
  // 金额整数部分
  let integerNum;
  // 金额小数部分
  let decimalNum;
  // 分离金额后用的数组，预定义
  let parts;
  // 输出的中文金额字符串
  let chineseStr = '';

  if (!isNaN(IsNum)) {
    n = n.toString();
    if (n.indexOf('.') === -1) {
      integerNum = n;
      decimalNum = '';
    } else {
      parts = n.split('.');
      integerNum = parts[0];
      decimalNum = parts[1];
    }
    //整数部分
    // 获取整型部分转换
    if (parseInt(integerNum, 10) > 0) {
      let zeroCount = 0;
      const IntLen = integerNum.length;
      for (let i = 0; i < IntLen; i++) {
        const n = integerNum.substr(i, 1);
        const p = IntLen - i - 1;
        const q = p / 4;
        const m = p % 4;
        if (n === '0') {
          zeroCount++;
        } else {
          if (zeroCount > 0) {
            chineseStr += digit[0];
          }
          // 归零
          zeroCount = 0;
          //alert(cnNums[parseInt(n)])
          chineseStr += digit[parseInt(n)] + unit[1][m];
        }
        if (m === 0 && zeroCount < 4) {
          chineseStr += unit[0][q];
        }
      }
    }
    //小数部分
    if (decimalNum !== '') {
      const decLen = decimalNum.length;
      if (chineseStr == '') {
        chineseStr = '零';
      }
      chineseStr += '点';
      for (let i = 0; i < decLen; i++) {
        const n = decimalNum.substr(i, 1);
        chineseStr += digit[Number(n)];
      }
    }
    return chineseStr;
  } else {
    return '';
  }
};
//失败弹框
export function alert(message) {
  if (requestStatus) {
    requestStatus = false;
    MessageBox.alert(
      "<div><img src='./static/img/error.png'/><div class='confirmTitle'>" +
        '操作失败！' +
        '</div>' +
        "<div class='confirmContent'>" +
        message +
        '</div></div>',
      '',
      {
        dangerouslyUseHTMLString: true,
        center: true,
        confirmButtonText: '确定',
        callback: () => {
          requestStatus = true;
        },
      }
    );
  }
}

// 确认弹窗
export function confirm(
  title = '删除数据？',
  content = '是否确认删除？',
  confirmButtonText = '确定',
  cancelButtonText = '取消'
) {
  return MessageBox.confirm(
    "<div><img src='./static/img/tips.png'/><div class='confirmTitle'>" +
      title +
      '</div>' +
      "<div class='confirmContent'>" +
      content +
      '</div></div>',
    '',
    {
      dangerouslyUseHTMLString: true,
      distinguishCancelAndClose: true, //区分取消与关闭
      cancelButtonText,
      confirmButtonText,
      center: true,
      customClass: 'confirm-box',
    }
  );
}

// 过滤对象中属性为空的值
export function filterEmpty(data) {
  const obj = {};
  for (let key in data) {
    if (data[key] || data[key] === 0 || typeof data[key] == 'boolean') {
      obj[key] = data[key];
    }
  }
  return obj;
}
/**
 * @desc 过滤整数，小数前面的无效0
 * @author 匡晓
 * @date 2020年4月28日
 * @param {String} num 需要格式化的数据
 * @returns {String} 格式化数据
 */
export function filterInvalidZero(num) {
  if (num % 1 === 0) {
    // 整数过滤前面的无效0
    num = num.replace(/\b(0+)/gi, '');
  } else {
    // 过滤小数前面的无效0
    num = num.replace(/^0+\./, '0.').replace(/^0+([0-9])/, '$1');
  }
  return num;
}

//判断搜索区域是否有值
/**
 * query:定义的查询条件
 * params:搜索时的返回参数
 */
export function isSearchEmpty(query, params) {
  let count = Object.keys(query).length;
  for (var key in params) {
    if (params[key] == '' || params[key] == null || params[key] == undefined) {
      count--;
    }
  }
  //如果返回0  则说明没有搜索条件
  return count;
}

export function dateFormatter(str) {
  //默认返回yyyy-MM-dd HH-mm-ss
  var hasTime = arguments.length > 1 ? true : false; //可传第二个参数false，返回yyyy-MM-dd
  var d = new Date(str);
  var year = d.getFullYear();
  var month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
  var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
  var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
  var minute = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
  var second = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
  if (hasTime) {
    return [year, month, day].join('-') + ' ' + [hour, minute, second].join(':');
  } else {
    return [year, month, day].join('-');
  }
}
// 驼峰转换下划线
export function toLine(name) {
  return name.replace(/([A-Z])/g, '_$1').toLowerCase();
}

const regexpZero = /(?:\.0*|(\.\d+?)0+)$/;
// 去掉小数点后面多余的0
export function spliceMoreZero(value) {
  if (!value) return value;
  return value.toString().replace(regexpZero, '$1');
}

// 验证错误跳转至第一个错误提示得地方
export function toFormErrorTop() {
  setTimeout(() => {
    const isError = document.getElementsByClassName('is-error');
    const inputList = isError[0].querySelectorAll('input');
    if (inputList.length > 0) {
      inputList[inputList.length - 1].focus();
    }
  }, 1);
}

// 将数组options返回会对象
export function optionsToObj(options) {
  const obj = {};
  options.forEach((item) => {
    obj[item.prop] = '';
    if (item.name) {
      obj[item.name] = '';
    }
    if (item.code) {
      obj[item.code] = '';
    }
  });
  return obj;
}

// 返回原对象中有的属性回
export function assignObj(sourceObj, data) {
  const obj = {};
  Object.keys(sourceObj).forEach((key) => {
    if (data[key] || data[key] === 0) {
      obj[key] = data[key];
    }
  });
  return Object.assign({}, sourceObj, obj);
}

// 银行家算法 寄进偶不进
export function round2(num, place = 6) {
  var tnum = Math.pow(10, place);
  if (
    Math.floor(num * tnum * 10) % 5 == 0 &&
    Math.floor(num * tnum * 10) == num * tnum * 10 &&
    Math.floor(num * tnum) % 2 == 0
  ) {
    return Math.floor(num * tnum) / tnum;
  } else {
    return Math.round(num, place);
  }
}
// 计算后保留多位小数，默认6位  不四舍五入
export function toFixedNumber(value, num = 6) {
  // value = round2( value, num)
  value = XEUtils.toFixedNumber(value, num);
  // value = fomatFloat(value,6)
  return parseFloat(value);
}

// 计算后保留多位小数，默认2位  四舍五入
export function toFixedNumberAmount(value, num = 2) {
  value = XEUtils.toNumber(value).toFixed(num || 2);
  return parseFloat(value);
}
// 计算后保留多位小数，有值就四舍五入 没有值不做修改
export function toFixedNumberAmountNew(value, num) {
  if (!num) return XEUtils.toNumber(value);
  value = XEUtils.toNumber(value).toFixed(num);
  return parseFloat(value);
}

// 单价格式化
export function toFixedPrice(value, num = 2) {
  return XEUtils.toNumber(value).toFixed(num);
}

// 金额格式化
export function toFixedAmout(value, num = 2) {
  return XEUtils.toNumber(value).toFixed(num);
}

// 数量格式化
export function toFixedQuantity(value, num = 2) {
  return XEUtils.toNumber(value).toFixed(num);
}

XEUtils.mixin({
  // 对象数组去重（根据key值判断）
  uniqObjArr(arr, key) {
    let hash = {}; //有助于增加遍历效率
    let newArry = arr.reduce((item, next) => {
      hash[next[key]] ? '' : (hash[next[key]] = true && item.push(next));
      return item;
    }, []);
    return newArry;
  },

  hasChina(s) {
    var patrn = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
    if (!patrn.exec(s)) {
      return false;
    } else {
      return true;
    }
  },

  calSum(arr, key) {
    if (!XEUtils.isArray(arr)) arr = [];
    let total = 0;
    arr.map((item) => {
      return (total = cal.calCommon(item[key], total, '+'));
    });
    return total;
  },
});

export function reportErrors(data) {
  if (data.code === 10) {
    MessageBox.confirm(
      "<div><img src='../../../static/img/tips.png'/>" +
        "<div class='repeatContent'>" +
        data.msg +
        '</div></div>',
      '',
      {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('salePurchase.message.submitAgain'),
        cancelButtonText: this.$t('confirm.cancel'),
        center: true,
        callback: (action) => {
          if (action === 'confirm') {
            data.callback();
          } else {
            this.$message({
              type: 'info',
              message: this.$t('salePurchase.message.gitUpSubmitAgain'),
            });
          }
        },
      }
    );
  } else {
    if (data.callback2) {
      data.callback2();
    }
    this.$message({
      type: 'info',
      message: data.msg,
    });
  }
}
